
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from '../components/explanations/comparisons-explanation';
const mainimage = '/Images/comparison1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "comparison" },
];

const Comparison = () => (
  <GrammarPageLayout
    level="A2"
    title="Comparison"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Comparatives and Superlatives Exercises"
    seoDescription="Compare people and things using comparative and superlative structures. A2 level practice."
    relatedCategory="grammar-exercises"
    relatedLevel="A2"
  />
);

export default Comparison;

